module.exports = __webpack_public_path__ + "images/marcador_motoboy.png?f0a4ab2e32bf98ebe7e0d6a858aeb550";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/marcador_motoboy.png
// module id = 992
// module chunks = 0